import { useNavigate } from "react-router-dom";
import { PageBanner } from "@/shared/components/PageBanner";
export function FormsHomePage() {
  const navigate = useNavigate();
  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="موتور فرم‌های پویا (Forms)"
        subtitle="مدیریت فرم‌ساز، قالب‌ها، و آرشیو فرم‌های پر شده"
        icon="📋"
        helpLink="/help/forms/home"
      />

      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "1.5rem" }}>
          
          <div style={{ background: "rgba(255, 255, 255, 0.03)", borderRadius: "16px", padding: "1.5rem", border: "1px solid var(--glass-border)" }}>
            <h3 style={{ fontSize: "1.1rem", fontWeight: 800, color: "#007270", marginBottom: "1rem", display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <span>⚙️</span> عملیات مدیریتی
            </h3>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
              <button 
                className="btn btn-primary" 
                onClick={() => navigate("/forms/families")}
                style={{ width: "100%", justifyContent: "flex-start" }}
              >
                مدیریت خانواده‌های فرم (Templates)
              </button>
            </div>
          </div>

          <div style={{ background: "rgba(255, 255, 255, 0.03)", borderRadius: "16px", padding: "1.5rem", border: "1px solid var(--glass-border)" }}>
            <h3 style={{ fontSize: "1.1rem", fontWeight: 800, color: "#007270", marginBottom: "1rem", display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <span>📊</span> گزارشات و آرشیو
            </h3>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
              <button 
                className="btn btn-secondary" 
                onClick={() => navigate("/forms/instances")}
                style={{ width: "100%", justifyContent: "flex-start", background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)" }}
              >
                آرشیو فرم‌های ثبت‌شده (Trace)
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
